import { render, staticRenderFns } from "./xtCusReportList.vue?vue&type=template&id=72aa90b7"
import script from "./xtCusReportList.vue?vue&type=script&lang=js"
export * from "./xtCusReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports